const customerCenterManager = [
  {
    path: '/customer-center',
    name: 'customer-center',
    component: () => import('@/views/wxapp/customer-center/'),
    meta: {
      title: '个人中心'
    },
    children: [
      {
        path: 'budget-quotation',
        name: 'budget-quotation',
        component: () => import('@/views/wxapp/customer-center/programme/budget-quotation'),
        meta: {
          title: '预算报价'
        }
      },
      {
        path: 'construction-delivery',
        name: 'construction-delivery',
        component: () => import('@/views/wxapp/customer-center/programme/construction-delivery'),
        meta: {
          title: '施工交付'
        }
      },
      {
        path: 'effect-collocation',
        name: 'effect-collocation',
        component: () => import('@/views/wxapp/customer-center/programme/effect-collocation'),
        meta: {
          title: '效果搭配'
        }
      },
      {
        path: 'functional-design',
        name: 'functional-design',
        component: () => import('@/views/wxapp/customer-center/programme/functional-design'),
        meta: {
          title: '功能设计'
        }
      },
      {
        path: 'functional-design-details',
        name: 'functional-design-details',
        component: () => import('@/views/wxapp/customer-center/programme/functional-design/details'),
        meta: {
          title: '功能设计'
        }
      },
      {
        path: 'plane-layout',
        name: 'plane-layout',
        component: () => import('@/views/wxapp/customer-center/programme/plane-layout'),
        meta: {
          title: '平面布局'
        }
      },
      {
        path: 'product-configuration',
        name: 'product-configuration',
        component: () => import('@/views/wxapp/customer-center/programme/product-configuration'),
        meta: {
          title: '产品配置'
        }
      },
      {
        path: 'product-configuration-details',
        name: 'product-configuration-details',
        component: () => import('@/views/wxapp/customer-center/programme/product-configuration/details'),
        meta: {
          title: '产品配置-详情'
        }
      },
      {
        path: 'value-added-services',
        name: 'value-added-services',
        component: () => import('@/views/wxapp/customer-center/programme/value-added-services'),
        meta: {
          title: '增值服务'
        }
      },
      {
        path: 'material-selection',
        name: 'material-selection',
        component: () => import('@/views/wxapp/customer-center/service/material-selection'),
        meta: {
          title: '选材清单'
        }
      }
    ]
  }
]
export default customerCenterManager
